var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Pipeline")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Follow the progress of your fundraising efforts and see which investors have shown interest in your offering."
      ),
    ]),
    _vm._v(" "),
    _vm.cur_user_id != 264 &&
    _vm.cur_user_id != 140 &&
    _vm.cur_user_id != 125 &&
    _vm.cur_user_id != 246 &&
    _vm.cur_user_id != 302 &&
    _vm.cur_user_id != 127 &&
    _vm.cur_user_id != 121 &&
    _vm.cur_user_id != 84 &&
    _vm.cur_user_id != 450 &&
    _vm.cur_user_id != 462 &&
    _vm.cur_user_id != 472 &&
    !_vm.is_premium
      ? _c("div", [
          _c("img", {
            staticStyle: {
              width: "100%",
              "max-width": "1280px",
              display: "block",
            },
            attrs: { src: "/images/pipeline_preview.png?t=2" },
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _c(
            "a",
            { staticClass: "pta-button", attrs: { href: "/account/calendar" } },
            [_vm._v("PROCEED TO BOOK A CALL WITH US")]
          ),
        ])
      : _c("div", [
          _c("div", { staticClass: "pta-pipeline-status" }, [
            _c("ul", [
              _c("li", [
                _c("span", [_vm._v(_vm._s(_vm.investors_number))]),
                _vm._v("Active Deals"),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", [
                  _vm._v(
                    "$" + _vm._s(_vm._f("formatAmount")(_vm.investors_amount))
                  ),
                ]),
                _vm._v("Average Deal Value"),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", [_vm._v(_vm._s(_vm.investors_completed))]),
                _vm._v("Number of "),
                _c("br"),
                _vm._v("meetings completed"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-pipeline-sort" }, [
            _c("ul", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "created_at"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "created_at"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "created_at"
                    },
                  },
                },
                [_c("span", [_vm._v("Date created")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "name"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "name"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "name"
                    },
                  },
                },
                [_c("span", [_vm._v("Name")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "amount"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "amount"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "amount"
                    },
                  },
                },
                [_c("span", [_vm._v("Value")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "closed_at"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "closed_at"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "closed_at"
                    },
                  },
                },
                [_c("span", [_vm._v("Close date")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "updated_at"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "updated_at"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "updated_at"
                    },
                  },
                },
                [_c("span", [_vm._v("Last updates")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.filterInvestorForm.sort_by == "pd_stage_id"
                      ? _vm.filterInvestorForm.order == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.filterInvestorForm.sort_by = "pd_stage_id"
                        ? _vm.filterInvestorForm.order == "desc"
                          ? (_vm.filterInvestorForm.order = "asc")
                          : (_vm.filterInvestorForm.order = "desc")
                        : (_vm.filterInvestorForm.order = "asc")
                      _vm.filterInvestorForm.sort_by = "pd_stage_id"
                    },
                  },
                },
                [_c("span", [_vm._v("Deal Stage")])]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pta-pipeline-campaigns" },
            _vm._l(_vm.investors.data, function (investor) {
              return _c("div", { staticClass: "pta-pipeline-campaign" }, [
                _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                  _c("h3", [_vm._v(_vm._s(investor.name))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "pta-pipeline-statusline pta-pipeline-size-13",
                      class:
                        _vm.show_index == investor.id
                          ? "pta-pipeline-show-labels pta-pipeline-color-" +
                            investor.color_id
                          : "pta-pipeline-color-" + investor.color_id,
                      attrs: { "data-id": "inv-stage-" + investor.pd_stage_id },
                    },
                    _vm._l(
                      _vm.pipeline_stages,
                      function (pipeline_stage, index) {
                        return _c(
                          "li",
                          {
                            class: _vm.isActiveStage(
                              index,
                              investor.pd_stage_id
                            ),
                            attrs: {
                              "data-id": "stage-" + pipeline_stage.pd_stage_id,
                            },
                          },
                          [
                            _c("div", [
                              _c("span", [_vm._v(_vm._s(pipeline_stage.name))]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "pta-pipeline-icon-show",
                    class:
                      _vm.show_index == investor.id
                        ? "pta-pipeline-icon-hide"
                        : "",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.show_index == investor.id
                          ? (_vm.show_index = 0)
                          : (_vm.show_index = investor.id)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                  _c("span", { staticClass: "pta-pipeline-amount" }, [
                    _vm._v(
                      "$" + _vm._s(_vm._f("formatAmount")(investor.amount))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pta-pipeline-date" }, [
                    _vm._v(_vm._s(_vm._f("momentDate")(investor.updated_at))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-pipeline-buttons" }, [
                  investor.investor
                    ? _c(
                        "a",
                        {
                          staticClass: "pta-pipeline-button",
                          attrs: {
                            href:
                              "https://proptecham.ai/account/investor-profile/" +
                              investor.investor.id,
                          },
                        },
                        [_vm._v("View Profile")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  investor.investor
                    ? _c(
                        "a",
                        {
                          staticClass: "pta-pipeline-button",
                          class:
                            investor.investor && investor.investor.website
                              ? ""
                              : "pta-pipeline-button-disable",
                          attrs: {
                            href: investor.investor.website
                              ? investor.investor.website.startsWith("http")
                                ? investor.investor.website.split(",")[0].trim()
                                : "https://" +
                                  investor.investor.website.split(",")[0].trim()
                              : "#",
                            target: investor.investor.website ? "_blank" : "",
                          },
                        },
                        [_vm._v("View website")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  investor.investor
                    ? _c(
                        "span",
                        {
                          staticClass: "pta-pipeline-button",
                          class: investor.investor
                            ? ""
                            : "pta-pipeline-button-disable",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              investor.investor
                                ? _vm.showNotes(
                                    investor.id,
                                    investor.investor_notes
                                  )
                                : false
                            },
                          },
                        },
                        [_vm._v("View deal notes")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "pta-pipeline-button",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.selected_index == investor.id
                            ? (_vm.selected_index = 0)
                            : (_vm.selected_index = investor.id)
                        },
                      },
                    },
                    [_vm._v("View details")]
                  ),
                ]),
                _vm._v(" "),
                _vm.selected_index == investor.id
                  ? _c("div", {
                      staticClass: "pta-pipeline-campaign-details",
                      domProps: {
                        textContent: _vm._s(
                          investor.description
                            ? investor.description
                            : "No information available yet."
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected_notes_index == investor.id
                  ? _c(
                      "div",
                      { staticClass: "pta-pipeline-campaign-details" },
                      [
                        _c("div", { staticClass: "row" }, [
                          investor.investor_notes.length
                            ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(investor.investor_notes.length) +
                                      " notes found. "
                                  ),
                                  !_vm.showNoteCreatePanel
                                    ? _c("i", {
                                        staticClass: "fas fa-plus-circle",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNoteCreatePanel =
                                              !_vm.showNoteCreatePanel
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    { staticClass: "table table-hover" },
                                    [
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          investor.investor_notes,
                                          function (note) {
                                            return note.user_investor_id ==
                                              _vm.selected_notes_index
                                              ? _c("tr", [
                                                  !note.pd_id
                                                    ? _c("td", [
                                                        note.creator_user
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "margin-bottom":
                                                                    "5px",
                                                                  "font-size":
                                                                    "12px",
                                                                  "line-height":
                                                                    "18px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "created by " +
                                                                    _vm._s(
                                                                      note
                                                                        .creator_user
                                                                        .profile
                                                                        .first_name
                                                                    ) +
                                                                    " on " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "moment"
                                                                      )(
                                                                        note.created_at
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !note.creator_user
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "margin-bottom":
                                                                    "5px",
                                                                  "font-size":
                                                                    "12px",
                                                                  "line-height":
                                                                    "18px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "created by " +
                                                                    _vm._s(
                                                                      note.creator_user_name
                                                                    ) +
                                                                    " on " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "moment"
                                                                      )(
                                                                        note.created_at
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(note.text) +
                                                            "\n                    "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  note.pd_id
                                                    ? _c("td", [
                                                        note.creator_user
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "margin-bottom":
                                                                    "5px",
                                                                  "font-size":
                                                                    "12px",
                                                                  "line-height":
                                                                    "18px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "created by " +
                                                                    _vm._s(
                                                                      note
                                                                        .creator_user
                                                                        .profile
                                                                        .first_name
                                                                    ) +
                                                                    " on " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "moment"
                                                                      )(
                                                                        note.created_at
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !note.creator_user
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "margin-bottom":
                                                                    "5px",
                                                                  "font-size":
                                                                    "12px",
                                                                  "line-height":
                                                                    "18px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "created by " +
                                                                    _vm._s(
                                                                      note.creator_user_name
                                                                    ) +
                                                                    " on " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "moment"
                                                                      )(
                                                                        note.created_at
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              note.text
                                                            ),
                                                          },
                                                        }),
                                                      ])
                                                    : _vm._e(),
                                                ])
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : !_vm.showNoteCreatePanel
                            ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c("h4", [
                                  _vm._v("No notes available. "),
                                  !_vm.showNoteCreatePanel
                                    ? _c("i", {
                                        staticClass: "fas fa-plus-circle",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNoteCreatePanel =
                                              !_vm.showNoteCreatePanel
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showNoteCreatePanel &&
                          _vm.selected_notes_index == investor.id
                            ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "form",
                                  {
                                    attrs: { autocomplete: "off" },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.submitInvestorNote(
                                          investor.investor_id
                                        )
                                      },
                                      keydown: function ($event) {
                                        return _vm.investorNoteForm.errors.clear(
                                          $event.target.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-sm-12" },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-group" },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                        attrs: { for: "" },
                                                      },
                                                      [_vm._v("New note")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("autosize-textarea", {
                                                      attrs: {
                                                        placeholder: "",
                                                        rows: "2",
                                                        name: "text",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.investorNoteForm
                                                            .text,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.investorNoteForm,
                                                            "text",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "investorNoteForm.text",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("show-error", {
                                                      attrs: {
                                                        "form-name":
                                                          _vm.investorNoteForm,
                                                        "prop-name": "text",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-info waves-effect waves-light pull-right",
                                        attrs: { type: "submit" },
                                      },
                                      [_vm._v(_vm._s(_vm.trans("general.add")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNoteCreatePanel =
                                              !_vm.showNoteCreatePanel
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.trans("general.cancel"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("span", [_vm._v("Lost Deals")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }